import { curry } from 'ramda';

import error, { getErrorObject } from '../../helpers/error';
import { toPrismicLang } from '../../helpers/i18n';
import { HTTP_CLIENT_ERROR_NOT_FOUND } from '../../helpers/http';

import { getByUID } from '../../api/prismic';

import { handleError } from '../errors';

import { ERROR } from 'translations';

export const LOAD_DOCUMENT_BY_UID_REQUEST = 'LOAD_DOCUMENT_BY_UID_REQUEST';
export const LOAD_DOCUMENT_BY_UID_SUCCESS = 'LOAD_DOCUMENT_BY_UID_SUCCESS';
export const LOAD_DOCUMENT_BY_UID_FAILURE = 'LOAD_DOCUMENT_BY_UID_FAILURE';

export const loadDocumentByUidRequest = (lang, type, uid) => ({
  type: LOAD_DOCUMENT_BY_UID_REQUEST,
  id: `${type}-${uid}`,
  lang,
});

export const loadDocumentByUidSuccess = (lang, type, uid, document) => ({
  type: LOAD_DOCUMENT_BY_UID_SUCCESS,
  payload: document,
  id: `${type}-${uid}`,
  lang,
});

export const loadDocumentByUidFailure = (lang, type, uid, error) => ({
  type: LOAD_DOCUMENT_BY_UID_FAILURE,
  payload: getErrorObject(error, ERROR.ERROR_LOADING_DOC_BY_UID, {
    type,
    uid,
  }),
  id: `${type}-${uid}`,
  lang,
});

export const getDocumentByUid = curry(
  (type, uid) => async (dispatch, getState) => {
    const { locale } = getState();
    const lang = toPrismicLang(locale);

    try {
      dispatch(loadDocumentByUidRequest(locale, type, uid));

      const document = await getByUID(type, uid, { lang });
      if (!document) {
        throw error(
          HTTP_CLIENT_ERROR_NOT_FOUND,
          `Document of type ${type} and uid "${uid}" couldn't be found`
        );
      }

      dispatch(loadDocumentByUidSuccess(locale, type, uid, document));
    } catch (error) {
      const fallback = loadDocumentByUidFailure(locale, type, uid, error);
      handleError(dispatch, error, fallback);
    }
  }
);
